import classnames from 'classnames';
import { memo, type FunctionComponent, type MouseEvent } from 'react';

import { Checkbox } from '@/domains/productDiscovery/Listings/components/Filters/components/newTamagoshiComponents/Checkbox/Checkbox';

import { Label } from '../../../Label/Label';
import { type ColorGroup, type Item } from '../../interfaces';
import { DotColor } from './components/DotColor';
import { colorTranslations } from './translations';

import styles from './ColorSelectItem.module.scss';

interface Props {
  className?: string;
  item: Item;
  onClick?(event: MouseEvent<HTMLInputElement>, item: Item): void;
}

export const ColorSelectItem: FunctionComponent<Props> = memo(
  ({ className, item, onClick }) => {
    const rootClassnames = classnames(styles.root, className);
    const isItemDisabled = !item?.count;

    const handleClick = (event: MouseEvent<HTMLInputElement>) => {
      if (onClick) {
        onClick(event, item);
      }
    };

    const label = (
      <Label
        label={colorTranslations[item.label as ColorGroup]}
        count={item.count || undefined}
        disabled={isItemDisabled}
      />
    );

    return (
      <Checkbox
        className={rootClassnames}
        id={`${item.id}-${item.value}`}
        isChecked={item.isRefined}
        value={item.isRefined}
        onClick={handleClick}
        isDisabled={isItemDisabled}
      >
        <DotColor colorName={item.value} checkbox />
        {label}
      </Checkbox>
    );
  },
);

ColorSelectItem.displayName = 'ColorSelectItem';
